import React from 'react';
import { Colors } from '@/constants/Colors';
import { useTheme } from '@/hooks/useTheme';

const TRACK_W = 48;
const THUMB = 22;
const PAD = 3;
const THUMB_ON_LEFT = TRACK_W - PAD - THUMB;

interface ToggleSwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  ariaLabel?: string;
}

export function ToggleSwitch({ checked, onChange, disabled = false, id, ariaLabel }: ToggleSwitchProps) {
  const colors = useTheme();

  return (
    <span
      style={{
        position: 'relative',
        width: TRACK_W,
        height: 28,
        borderRadius: 14,
        backgroundColor: checked ? Colors.primary : colors.border,
        flexShrink: 0,
        transition: 'background-color 0.2s ease',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <input
        id={id}
        type="checkbox"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0,
          width: '100%',
          height: '100%',
          margin: 0,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      />
      <span
        aria-hidden
        style={{
          pointerEvents: 'none',
          position: 'absolute',
          top: PAD,
          left: checked ? THUMB_ON_LEFT : PAD,
          width: THUMB,
          height: THUMB,
          borderRadius: '50%',
          backgroundColor: '#fff',
          transition: 'left 0.2s ease',
          boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
        }}
      />
    </span>
  );
}
